import React, { useEffect } from 'react';
import { Virtual, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import PlacementCustomCard from 'src/components/customCard/PlacementCustomCard';
import DriveCustomCard from 'src/components/customCard/DriveCustomCard';
import { useGetAllDrivesQuery } from 'src/hooks/drives.hooks';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
const UpdatedPlacementDrive = () => {
	let { data } = useGetAllDrivesQuery();

	const scrollLeft = () => {
		const scrollContainer = document.getElementById('drive-container');
		if (scrollContainer && data?.drives && data.drives.length > 2) {
			scrollContainer.scrollTo({
				left: scrollContainer.scrollLeft - 290,
				behavior: 'smooth',
			});
		}
	};

	const scrollRight = () => {
		const scrollContainer = document.getElementById('drive-container');
		if (scrollContainer && data?.drives && data.drives.length > 2) {
			scrollContainer.scrollTo({
				left: scrollContainer.scrollLeft + 290,
				behavior: 'smooth',
			});
		}
	};

	return (
		<div
			// className={`flex flex-col md:flex-row gap-[15px] ${
			// 	data?.drives.length !== 0 ? 'gap-[24px] md:justify-center:gap-[24px]' : 'gap-[24px]'
			// } md:items-center mt-[25px] md:mt-[50px] w-full mx-auto`}

			className={`flex flex-col md:flex-row gap-[15px] ${
				!data?.drives || data.drives.length === 0
					? 'md:gap-[28px]'
					: data.drives.length <= 2
					  ? 'md:gap-[46px]'
					  : 'md:justify-center md:gap-[24px]'
			} md:items-center mt-[25px] md:mt-[50px] w-full mx-auto`}
		>
			<div className="flex item-left">
				<PlacementCustomCard
					title="Placement Drives"
					description="Register and close your hiring needs within 6 hours"
					imageSrc="/assets/recruiterImages/placementDriveIcon.svg"
				/>
			</div>

			<div className="block md:hidden">
				{data?.drives.length !== 0 ? (
					<div className="flex flex-row gap-[10px] overflow-x-auto w-[91%] mx-auto md:mx-0 md:!max-w-[60%]">
						{data?.drives.map((card, index) => (
							<DriveCustomCard
								id={card._id}
								key={card._id}
								image={'/assets/calender.png'}
								title={card.city + ' Placement Drive'}
								location={card.location}
								time={card.driveDate}
								isRegistered={card.isRegistered}
								totalParticipating={card.totalParticipating}
							/>
						))}
					</div>
				) : (
					<>
						<div className="flex flex-row gap-[10px] overflow-x-auto w-[91%] mx-auto md:mx-0 md:!max-w-[60%]">
							<div className="max-w-[280px] w-full flex flex-row rounded-[8px] border border-[#EBEBF0] bg-[#FFF] relative cursor-pointer">
								<div className="px-[31px] py-[14px]">
									<div className="flex flex-col font-inter gap-[10px]">
										<h1 className="text-[#1C1C28] text-[14px] leading-[20px] font-[600] text-center">
											No Upcoming Drives
										</h1>
										<p className="text-[#555770] text-center text-[12px] leading-[16px] font-[400]">
											Details for the upcoming placement drives will be shared soon
										</p>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>

			{/* Button-based scrolling implementation */}
			{data?.drives.length !== 0 ? (
				<div
					// className={`flex-1 max-w-[68%] mx-auto hidden md:block `}
					className={`flex-1 max-w-[68%] mx-auto hidden md:block ${
						data?.drives && data.drives.length <= 2 ? 'tlg:!max-w-[1089px]' : ''
					}`}
				>
					<div className="flex justify-between items-center gap-[10px] md:mx-0 max-w-[85%] mx-auto">
						{data?.drives && data.drives.length > 2 && (
							<button
								onClick={scrollLeft}
								className="w-[30px] h-[94px] border border-[#EBEBF0] bg-[#FFF] rounded-[6px] text-center"
							>
								<BiChevronLeft size={30} color="#30B0C7" />
							</button>
						)}

						<div
							id="drive-container"
							className="flex flex-row gap-[10px] overflow-x-auto w-[91%] max-w-[94%] mx-auto scrollbar-hide"
						>
							{data?.drives.map(card => (
								<DriveCustomCard
									id={card._id}
									key={card._id}
									image={'/assets/calender.png'}
									title={card.city + ' Placement Drive'}
									location={card.location}
									time={card.driveDate}
									isRegistered={card.isRegistered}
									totalParticipating={card.totalParticipating}
								/>
							))}
						</div>
						{data?.drives && data.drives.length > 2 && (
							<button
								onClick={scrollRight}
								className="w-[30px] h-[94px] border border-[#EBEBF0] bg-[#FFF] rounded-[6px] text-center"
							>
								<BiChevronRight size={30} color="#30B0C7" />
							</button>
						)}
					</div>
				</div>
			) : (
				<>
					<div className="md:mx-0 pl-[52px] max-w-full mx-auto hidden md:block">
						<div className="max-w-[280px] w-full flex flex-row rounded-[8px] border border-[#EBEBF0] bg-[#FFF] relative cursor-pointer">
							<div className="px-[31px] py-[16px]">
								<div className="flex flex-col font-inter gap-[10px]">
									<h1 className="text-[#1C1C28] text-[14px] leading-[20px] font-[600] text-center">
										No Upcoming Drives
									</h1>
									<p className="text-[#555770] text-center text-[12px] leading-[16px] font-[400]">
										Details for the upcoming placement drives will be shared soon
									</p>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default UpdatedPlacementDrive;
